import React from 'react'
import get from 'lodash/get'
import TextProductOption from './TextProductOption'
import SwatchProductOption from './SwatchProductOption'

// Local replacement for react-storefront/option/ProductOption.
// Chooses the text or swatch presentation and manages selected state via
// the selectedOption / onSelectedOptionChange pair.
const noop = () => {}

export default function ProductOption(props) {
  const {
    value,
    selected: selectedProp,
    selectedOption,
    onSelectedOptionChange,
    onClick,
    variant,
    showLabel = true,
    wrapperProps = noop,
    optionProps = noop,
    selectedClassName = 'rsf-po-selected',
    ...others
  } = props

  let selected = selectedProp
  if (selectedOption) {
    selected = get(value, 'id') == get(selectedOption, 'id')
  }

  const handleClick = e => {
    if (onClick) onClick(e)
    if (onSelectedOptionChange) {
      onSelectedOptionChange(selected ? null : value)
    }
  }

  const Variant = variant === 'text' ? TextProductOption : SwatchProductOption
  const propArgs = { selected, ...props }

  return (
    <div className={selected ? selectedClassName : ''} {...wrapperProps(propArgs)}>
      <Variant
        {...others}
        {...optionProps(propArgs)}
        label={showLabel ? value && value.text : undefined}
        selected={selected}
        onClick={handleClick}
        disabled={get(value, 'disabled')}
      />
    </div>
  )
}
